<template>
    <div class="apprentice-simple-card">
        <h3 class="title">{{ $t('common.password') }}</h3>
        <div class="description">{{ $t('user_account.password.edit_password_description') }}</div>

        <div class="row">
            <div class="col-md-6">
                <b-form
                    @submit="onSubmit"
                    @reset="onReset">
                    <b-form-group
                        id="input-group-1"
                        :label="$t('user_account.password.current_password')"
                        label-for="input-1">
                        <b-form-input
                            id="input-1"
                            v-model="current_password"
                            type="password"
                            required
                            :placeholder="$t('user_account.password.current_password')"></b-form-input>

                        <div v-if="errors.password">
                            <label class="error mt-2 text-danger">{{ errors.password[0] }}</label>
                        </div>
                    </b-form-group>

                    <b-form-group
                        id="input-group-2"
                        :label="$t('user_account.password.new_password')"
                        label-for="input-2">
                        <b-form-input
                            id="input-2"
                            v-model="password"
                            type="password"
                            required
                            :placeholder="$t('user_account.password.new_password')"
                            :class="{ valid: passwordValidation.valid }"></b-form-input>

                        <div v-if="errors.password">
                            <label class="error mt-2 text-danger">{{ errors.password[0] }}</label>
                        </div>
                    </b-form-group>

                    <b-form-group
                        id="input-group-3"
                        :label="$t('user_account.password.confirm_password')"
                        label-for="input-3">
                        <b-form-input
                            id="input-3"
                            v-model.lazy="checkPassword"
                            type="password"
                            required
                            :placeholder="$t('user_account.password.confirm_password')"></b-form-input>
                    </b-form-group>

                    <b-button
                        v-if="passwordsFilled && !notSamePasswords && passwordValidation.valid"
                        type="submit"
                        variant="primary"
                        >{{ $t('common.save') }}
                    </b-button>
                </b-form>
            </div>
            <div class="col-md-6">
                <transition
                    name="hint"
                    appear>
                    <div
                        class="hints"
                        v-if="passwordValidation.errors.length > 0 && !submitted">
                        <p>{{ $t('user_account.password.minimum_requirements_password') }}</p>
                        <ul style="color: red">
                            <li v-for="error in passwordValidation.errors">{{ error }}</li>
                        </ul>
                    </div>
                </transition>

                <div
                    class="matches"
                    v-if="notSamePasswords">
                    <p class="color: red;">{{ $t('user_account.password.passwords_do_not_match') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-user-account-password-component',
    data() {
        return {
            current_password: '',
            errors: [],
            rules: [
                { message: this.$t('user_account.password.minimum_8_characters'), regex: /.{8,}/ },
                { message: this.$t('user_account.password.at_least_1_number'), regex: /[0-9]+/ },
                { message: this.$t('user_account.password.at_least_1_number'), regex: /[A-Z]+/ },
                {
                    message: this.$t('user_account.password.at_least_1_special_character'),
                    regex: /[!@#\$%\^\&*\)\(+=._-]/,
                },
            ],
            password: '',
            checkPassword: '',
            submitted: false,
        };
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();

            let form = {
                current_password: this.current_password,
                password: this.password,
                password_confirm: this.checkPassword,
            };

            this.alert.saving();
            this.axios.post(this.routes.accountPasswordSubmit(), form).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onReset(evt) {
            evt.preventDefault();
            // Reset our form values
            this.current_password = '';
            this.password = '';
            this.password_confirm = '';
        },
    },
    computed: {
        notSamePasswords() {
            if (this.passwordsFilled) {
                return this.password !== this.checkPassword;
            } else {
                return false;
            }
        },
        passwordsFilled() {
            return this.password !== '' && this.checkPassword !== '';
        },
        passwordValidation() {
            let errors = [];

            if (this.password == '') {
                return { valid: true, errors };
            }

            for (let condition of this.rules) {
                if (!condition.regex.test(this.password)) {
                    errors.push(condition.message);
                }
            }
            if (errors.length === 0) {
                return { valid: true, errors };
            } else {
                return { valid: false, errors };
            }
        },
    },
};
</script>

<style scoped lang="scss">
.title {
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
}

.description {
    margin-bottom: $grid-gutter-width;
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    font-size: $base-font-size;
}
</style>
